import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {
	CandidateApplicationHistory,
	CurrentOpeningsMenu,
	dashboardMenu,
	dashboardPagesMenu,
	FeedbackParameterList,
	FeedbackParameterMenu,
	jobrequisitionMenu,
	OfferListMenu,
	QuestionariesListMenu,
	ScheduledInterviewsMenu,
	userManagement,
} from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import usePermissions from '../../../components/utils/PermissionChecking';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const [doc, setDoc] = useState(
		localStorage.getItem('facit_asideDocStatus') === 'true' || false,
	);
	const { t } = useTranslation(['translation', 'menu']);
	const { hasPermission } = usePermissions();

	const storedData = localStorage.getItem('HRMS-data');
	const accessData = storedData ? JSON.parse(storedData) : null;
	const allowedModules =
		accessData?.access?.modules?.map((mod: { module: string }) =>
			mod.module.toLowerCase().trim(),
		) || [];

	const isSuperAdmin = accessData?.userType === 'superadmin';

	const filteredDashboardMenuObj = isSuperAdmin
		? dashboardPagesMenu
		: Object.fromEntries(
			Object.entries(dashboardPagesMenu).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);
	const filteredJobRequisitionMenu = isSuperAdmin
		? jobrequisitionMenu
		: Object.fromEntries(
			Object.entries(jobrequisitionMenu).filter(([key, item]) => {
				let moduleName = item.text?.toLowerCase().trim();

				if (moduleName === 'requirement') {
					moduleName = 'job requisition';
				}

				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);


	const filteredFeedbackMenu = isSuperAdmin
		? FeedbackParameterList
		: Object.fromEntries(
			Object.entries(FeedbackParameterList).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);

	const filterUserMenu = isSuperAdmin
		? userManagement
		: Object.fromEntries(
			Object.entries(userManagement).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);

	const filterInterviewMenu = isSuperAdmin
		? ScheduledInterviewsMenu
		: Object.fromEntries(
			Object.entries(ScheduledInterviewsMenu).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);

	const filterOfferMenu = isSuperAdmin
		? OfferListMenu
		: Object.fromEntries(
			Object.entries(OfferListMenu).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);
	const CurrentOpeningMenu = isSuperAdmin
		? CurrentOpeningsMenu
		: Object.fromEntries(
			Object.entries(CurrentOpeningsMenu).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);
	const QuestionariesMenu = isSuperAdmin
		? QuestionariesListMenu
		: Object.fromEntries(
			Object.entries(QuestionariesListMenu).filter(([key, item]) => {
				const moduleName = item.text?.toLowerCase().trim();
				const moduleAllowed = allowedModules.includes(moduleName);
				const hasViewPermission = hasPermission(moduleName, 'view');
				return moduleAllowed && hasViewPermission;
			}),
		);
	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={dashboardMenu} id='aside-dashboard' />
				<Navigation menu={filteredDashboardMenuObj} id='aside-dashboard' />
				<Navigation menu={filterUserMenu} id='user-management' />
				<NavigationLine />
				<Navigation menu={QuestionariesMenu} id='questionaries' />
				<Navigation menu={filteredJobRequisitionMenu} id='job-management' />
				<NavigationLine />
				<Navigation menu={filteredFeedbackMenu} id='offer-setting' />
				<Navigation menu={filterOfferMenu} id='offer-management' />
				<NavigationLine />
				<Navigation menu={CurrentOpeningMenu} id='current-openings' />
				<Navigation menu={filterInterviewMenu} id='Scheduled-Interviews' />

				{/* <Navigation menu={CandidateApplicationHistory} id='Scheduled-Interviews' /> */}
				{asideStatus && doc && <div className='p-4'>Documentation</div>}
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
